export default __webpack_public_path__ + "static/media/noun_invoice_3492253.6539acd7.svg";